import { getUrl } from "@insite/client-framework/ServerSideRendering";
import { getThemeFromDomain as getThemeFromDomainDesign, THEME_CONFIG } from "@tSurya/theme/design";

export const THEME_IDS = {
    SURYA: "surya",
    GLOBAL_VIEWS: "globalviews",
    MGBW: "mgbw",
} as const;

export type ThemeId = typeof THEME_IDS[keyof typeof THEME_IDS];

export function getActiveThemeId(): ThemeId {
    if (typeof window !== "undefined") {
        return getThemeFromDomainDesign(window.location.hostname) as ThemeId;
    }

    // Server: resolve from request URL
    try {
        const url = getUrl();
        if (url) {
            return getThemeFromDomainDesign(url.hostname) as ThemeId;
        }
    } catch (_e) {
        // No request context (module load time)
    }
    return THEME_IDS.SURYA;
}

export function isThemeActive(themeId: ThemeId): boolean {
    return getActiveThemeId() === themeId;
}
